
import Schema from "async-validator";
import dateJs from '@/assets/js/date'

const messageConfig = require("@/models/messageConfig");
// 数字类型自定义验证
const NumberValidation = (rule, value) => {
  return (value !== "" && parseFloat(value) !== "NaN" && !isNaN(value));
};


const ProductionChangeSaveRule = {
  productionDate: {
    required: true,
    message: messageConfig.getMessage("validformrequire")
  },
  productionCostType: {
    required: true,
    message: messageConfig.getMessage("validformrequire")
  },
  salesAmount: {
    message: messageConfig.getMessage("moneyerror"),
    validator (rule, value, callback, source) {

      if (value === "") { return true }

      const validate = NumberValidation(rule, value)
      source.salesAdminAmount = !validate ? "1" : value

      return validate
    }
  },
  salesAdminAmount: [{
    required: true,
    message: messageConfig.getMessage("validformrequire")
  }, {
    message: messageConfig.getMessage("moneyerror"),
    validator (rule, value) {

      const validate = NumberValidation(rule, value)

      if (!validate || (validate && parseFloat(value) === 0)) {
        return false
      }
      return true
    }
  }],
}


const ProductionChangeInputRule = {
  salesAmount: ProductionChangeSaveRule.salesAmount,
  salesAdminAmount: ProductionChangeSaveRule.salesAdminAmount,
}



const postDateValidation = (rule, value) => {
  return (value.postDateType === 'StartFrom' && (value.postDate ?? '') !== '') || value.postDateType !== 'StartFrom'
}
const depostDateValidation = (rule, value) => {
  return (value.depostDateType === 'DepostOnOrBefore' && (value.depostDate ?? '') !== '') || value.depostDateType !== 'DepostOnOrBefore'
}

const OperationChangeItemRule = {
  postDateType: {
    required: true,
    message: messageConfig.getMessage("validformrequire")
  },
  depostDateType: {
    required: true,
    message: messageConfig.getMessage("validformrequire")
  },
  postDate: [{
    message: messageConfig.getMessage("validformrequire"),
    validator: postDateValidation
  }, {
    message: messageConfig.getMessage("postgtdate"),
    validator (rule, value) {
      if (value.postDateType !== "StartFrom") {
        return true;
      }
      return value.postDateType === "StartFrom" &&
        dateJs.DateDiff(value.startDate, value.postDate) <= 0
    }
  }],
  depostDate: [{
    message: messageConfig.getMessage("validformrequire"),
    validator: depostDateValidation
  }, {
    message: messageConfig.getMessage("depostltdate"),
    validator (rule, value) {
      if (value.depostDateType !== "DepostOnOrBefore") {
        return true;
      }
      return value.depostDateType === "DepostOnOrBefore" &&
        dateJs.DateDiff(value.endDate, value.depostDate) >= 0
    }
  }],
}

const productionChangeValidation = {
  /**
   * 更新上画验证
   * @param {*} source 验证信息
   * @returns 
   */
  async ProductionChangeSaveValidation (source) {
    var validator = new Schema(ProductionChangeSaveRule);

    var errors;

    await validator
      .validate(source)
      .then(() => { })
      .catch((errs) => {
        errors = errs.errors;
      });

    return errors || [];
  },
  async OperationChangeItemValidation (source) {

    const data = {
      postDateType: source.postDateType,
      postDate: {
        postDate: source.postDate,
        postDateType: source.postDateType,
        startDate: source.startDate
      },
      depostDateType: source.depostDateType,
      depostDate: {
        depostDate: source.depostDate,
        depostDateType: source.depostDateType,
        endDate: source.endDate
      }
    }


    var validator = new Schema(OperationChangeItemRule);

    var errors;

    await validator
      .validate(data)
      .then(() => { })
      .catch((errs) => {
        errors = errs.errors;
      });


    return errors || [];
  },
  async OperationSaveValidation (source) {

    var errors = [];
    for (var i = 0; i < source.length; i++) {
      const data = source[i]
      const id = data.id;
      var validation = await this.OperationChangeItemValidation(data).then(res => res)
      if (validation.length > 0) {
        errors.push({ id, validation })
      }
    }

    return errors;
  },
  async ProductionChangeInputValidation (source) {
    var validator = new Schema(ProductionChangeInputRule);

    var errors;

    await validator
      .validate(source)
      .then(() => { })
      .catch((errs) => {
        errors = errs.errors;
      });

    return errors;
  }
}


export default productionChangeValidation
